export const Popup = () => {


    const popup = document.querySelector('.popup');

    if (!popup) {

        return;
    }

    const close = popup.querySelector('.popup__close');

    close.addEventListener('click', (event) => {
        popup.classList.add('popup--inactive');

    });


    checkFragmentIdentifier();

    function checkFragmentIdentifier() {

        if (window.location.hash) {
            const hash = window.location.hash;

            switch (hash) {
                case '#nolax':
                case '#nolax-en':
                    showPopup('nolax');
                    break;
                case '#emerell':
                case '#emerell-en':
                    showPopup('emerell');
                    break;
                case '#meraxo':
                case '#meraxo-en':
                    showPopup('meraxo');
                    break;
                default:
            }
        }
    }

    function showPopup(hash) {
        popup.classList.add('popup--' + hash);
        popup.classList.remove('popup--inactive');

    }


};